import React, { useEffect, useState } from "react";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import { fDate, useDateUtils } from "../../../../utils/formatTime";
import { CSVExport } from "../../../components/ui-component/table/CSVExport";

export default function RecycleRequestHyperlink({
  detailsData,
  rowData,
  filterType,
  fromDate,
  toDate,
  userWise,
  isDownloadAccess
}) {
  const userRole = localStorage.getItem("userRole");
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
    const [exportData, setExportData] = useState([]);

  const columns = [
    {
      field: "name",
      headerName: "Name",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.enquiry_id?.first_name || ""}{" "}
    ${params.row?.last_name}`,
      renderCell: (params) => (
        <div>
          {" "}
          <div>
            <Button
              size="small"
              onClick={() =>
                window.open(`/enquirydetails/${params?.row?.enquiry_id?.id}`, "_blank")
              }
            >
              {params.row?.enquiry_id?.first_name}{" "}
              {params.row?.enquiry_id?.last_name ? params.row?.enquiry_id?.last_name : ""}
            </Button>
          </div>
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "phone",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.enquiry_id?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.enquiry_id?.mobile}
        </div>
      ),
    },
    {
      field: "enquiry_date",
      headerName: "Enquiry Date",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.enquiry_date || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.enquiry_date}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "nearest_branch",
      headerName: "Nearest  Branch",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.nearest_branch_id?.branch_name || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.nearest_branch_id?.branch_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "service",
      headerName: "Service",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.service_id?.service_name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.service_id?.service_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subService",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.sub_service_id?.name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.sub_service_id?.name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "leadSource",
      headerName: "Lead Source",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.lead_source_type_id?.name || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.lead_source_type_id?.name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "sublead",
      headerName: "Sub Lead Source",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.sub_lead_source_type_id?.source_type || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.sub_lead_source_type_id?.source_type}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "prospective_level",
      headerName: "Prospective Level",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.prospective_level_id?.prospective_level || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.prospective_level_id?.prospective_level}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "campaign",
    //   headerName: "Sub Lead Source",
    //   width: 150,
    //   headerClassName: "header-cell",
    //   valueGetter: (params) =>
    //     params.row?.enquiry_id?.sub_lead_source_type_id?.source_type || "",
    //   renderCell: (params) => (
    //     <div>
    //       {params.row?.enquiry_id?.sub_lead_source_type_id?.source_type}
    //     </div>
    //   ),
    //   headerAlign: "center",
    //   align: "center",
    // },

    {
      field: "stage",
      headerName: "Stages",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.stage_id?.stage_name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.stage_id?.stage_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "branchName",
      headerName: " Branch",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.branch_id?.branch_name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.branch_id?.branch_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "assign_to",
      headerName: "Assign To",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.enquiry_id?.assign_to?.first_name || ""}{" "}
    ${params.row?.enquiry_id?.assign_to?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.assign_to?.first_name} {params.row?.enquiry_id?.assign_to?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "recycleBy",
      headerName: "Recycled By",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.recycle_by?.first_name || ""}{" "}
    ${params.row?.recycle_by?.last_name}`,
      renderCell: (params) => (
        <div>
          {params.row?.recycle_by?.first_name}{" "}
          {params.row?.recycle_by?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "recycleReson",
      headerName: "Recycle Reason",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.request_reason_id?.recycle_reason || "",
      renderCell: (params) => (
        <div>{params.row?.request_reason_id?.recycle_reason}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "requested_date",
      headerName: "Requested Date",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params.row?.status === "pending" ? (
            <Chip
              size="small"
              label="Pending"
              variant="contained"
              sx={{ background: "#CFA31C", color: "white" }}
            />
          ) : params.row?.status === "accepted" ? (
            <Chip
              variant="contained"
              size="small"
              label="Accepted"
              color="secondary"
            />
          ) : params.row?.status === "cancelled" ? (
            <Chip
              variant="contained"
              size="small"
              label="Cancelled"
              color="error"
            />
          ) : params.row?.status === "reopen" ? (
              <Chip
                variant="contained"
                size="small"
                label="Reopened"
                color="primary"
              />
          ) : (
            " "
          )}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
  ];

  // DownLoad Report
    useEffect(() => {
        const exportData = detailsData.map((row) => ({
          name: row?.enquiry_id?.last_name
            ? `${row?.enquiry_id?.first_name} ${row?.enquiry_id?.last_name}`
            : row?.enquiry_id?.first_name,
          mobile_country_code: row?.enquiry_id?.mobile_country_code || "",
          mobile: row?.enquiry_id?.mobile || "",
          enquiry_date: fDate(row?.enquiry_id?.enquiry_date || ""),
          nearest_branch: row?.enquiry_id?.nearest_branch_id?.branch_name || "",
          service: row?.enquiry_id?.service_id?.service_name,
          sub_service: row?.enquiry_id?.sub_service_id?.name,
          lead_source: row?.enquiry_id?.lead_source_type_id?.name,
          sub_lead_source: row?.enquiry_id?.sub_lead_source_type_id?.source_type,
          prospective_level: row?.enquiry_id?.prospective_level_id?.prospective_level,
          stage: row?.enquiry_id?.stage_id?.stage_name,
          branch: row?.enquiry_id?.branch_id?.branch_name,
          assign_to: `${row?.enquiry_id?.assign_to?.first_name || ""} ${
            row?.enquiry_id?.assign_to?.last_name || ""
          }`,
          recycle_by: `${row?.recycle_by?.first_name || ""} ${
            row?.recycle_by?.last_name || ""
          }`,
          recycle_reason: row?.request_reason_id?.recycle_reason,
          recycle_date: fDate(row?.requested_date),
          action_by: `${row?.action_by?.first_name || ""} ${
            row?.action_by?.last_name || ""
          }`,
          status: row?.status,
        }));
        setExportData(exportData);
      }, [detailsData]);
  
  return (
    <>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", flexDirection: "row", gap: 5 }}
        >
          {userWise ? (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Typography variant="h5"> Recycled By :</Typography>
              <Typography ml={1}>
                {rowData?.first_name} {rowData?.last_name}
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Typography variant="h5"> Campaign Name :</Typography>
              <Typography ml={1}>{rowData?.campaign_name}</Typography>
            </Box>
          )}

          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Typography variant="h5" mr={1}>Recycled Date :</Typography>

            {/* {filterType === "default" && (
              <Typography variant="h4" textAlign="center">
                {monthName} {selectedYear}
              </Typography>
            )} */}

            {filterType === "today" && (
              <Typography>Today ({currentDate})</Typography>
            )}
            {filterType === "currentweek" && (
              <Typography>This Week ({weekRange})</Typography>
            )}

            {filterType === "currentmonth" && (
              <Typography>
                {currentMonthName} {currentYear}
              </Typography>
            )}

            {filterType === "custom" && (
              <Typography>
                {fromDate} - {toDate}
              </Typography>
            )}
          </Box>
        </Grid>
          <Grid
                        item
                        xs={12}
                        md={6}
                      
                    
                        textAlign='end'
                        gap={1}
                      >

                        {isDownloadAccess && (
                          <CSVExport
                            data={exportData}
                            filename="recycle-enquiry-report.csv"
                          />
                        )}
                      </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={detailsData}
            columns={columns}
            autoHeight
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
            disableRowSelectionOnClick
          />
        </Grid>
      </Grid>
    </>
  );
}
